import React from 'react';
import EnglishInterviewSuccess from 'components/organisms/interview-success/eng';
import './interview-success.scss';

const PublicInterviewSuccessPage = () => {
  return <EnglishInterviewSuccess />;
};

export default PublicInterviewSuccessPage;
